var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPhone = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.9102,
    cy: 19.108,
    r: 19,
    fill: "#ACCE42"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8624 24.4287C18.3004 23.9416 17.2512 22.9299 16.6517 22.3304C15.3777 21.0564 13.804 19.2953 12.3052 17.0471C11.2935 15.5483 11.4808 13.5624 12.7548 12.2884L14.2911 10.7521C14.5159 10.5273 14.8531 10.5273 15.078 10.7521L17.3636 13.0378C17.5885 13.2626 17.5885 13.5999 17.3636 13.8247L16.6517 14.5366C16.4643 14.724 16.3894 15.0237 16.4643 15.3235C16.839 16.4101 17.6259 18.1338 19.2371 19.745C20.8484 21.3562 22.6094 22.1431 23.6961 22.5178C23.9584 22.6302 24.2581 22.5552 24.483 22.3304L25.1949 21.6185C25.4197 21.3937 25.7569 21.3937 25.9818 21.6185L28.2674 23.9042C28.4923 24.129 28.4923 24.4662 28.2674 24.691L26.6937 26.2273C25.4197 27.5013 23.4338 27.6886 21.9725 26.7144C21.7851 26.5645 21.5603 26.4521 21.3729 26.3022",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.910156 0.107971H38.9102V38.108H0.910156V0.107971Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.543,
    y: 9.74045,
    width: 18.7351,
    height: 18.7351,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Phone.112754c5.svg";
export { ForwardRef as ReactComponent };